import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import { SimpleSelectField } from '@unite-us/app-components';
import { required } from 'src/common/form/utils/rffValidations';
import './stylesheets/referralNetworkSelector.scss';

const ReferralNetworksSelector = ({
  isFetchingNetworkGroups,
  networks,
}) => {
  const { input, meta } = useField('referred_by_network', { validate: required });

  // Auto-select when only one network option exists
  useEffect(() => {
    if (networks.length === 1 && input.value !== networks[0].id) {
      input.onChange(networks[0].id);
    }
  }, [networks]);

  return (
    <div className="referral-networks-selector">
      <div className="service-type-section row">
        <div className="col-md-6 col-xs-12">
          <SimpleSelectField
            id="service-type-network"
            className="service-type-network-select"
            label="Sending Network"
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            options={networks}
            optionSettings={{ labelKey: 'name', valueKey: 'id' }}
            disabled={isFetchingNetworkGroups}
            error={meta.touched ? meta.error : undefined}
            required
          />
        </div>
      </div>
    </div>
  );
};

ReferralNetworksSelector.propTypes = {
  isFetchingNetworkGroups: PropTypes.bool.isRequired,
  networks: PropTypes.array.isRequired,
};

export default ReferralNetworksSelector;
